(function ($, Drupal) {

  // Footer behaviors (Toggle nav list)
  Drupal.behaviors.initFooterMenu = {
    attach: function (context, settings) {

      $('.js_footer', context).once('initFooterMenu').each(function () {

        let $el = $(this),
            $link = $el.find('.footer__section h2'),
            $list = $el.find('.footer__menu'),
            $resPixel = $('.js_resolution');

        $link.on('click', function(evt) {

          if ($resPixel.css('opacity') >= '1') {
            return false
          }

          evt.preventDefault();

          let $this = $(this),
            $sibling = $this.siblings('.footer__menu');

          if (!$sibling.hasClass('is_active')) {
            $list.removeClass('is_active');
            $link.removeClass('is_active');
            $this.addClass('is_active');
            $sibling.addClass('is_active');
          } else {
            $this.removeClass('is_active');
            $sibling.removeClass('is_active');
          }
        });

      });
    }
  };

})(jQuery, Drupal);